var site = site || {};
site.productView = site.productView || {};


$(document).on('prodcat.status', function(e, data) {
  var isMpp = 0;
  var productStatus = [];

  $.each(data.products, function(index, product) {
    if (product) {
      var skus = product.skus;
      $.each(skus, function(index, sku) {
        // save the data somewhere
        $(document).data(sku.SKU_ID, sku);
      });

      // COMING_SOON[3], SOLD_OUT[7], TEMP_OUT_OF_STOCK[2]
      var notShoppable = _.filter(skus, function(sku){
        return sku['INVENTORY_STATUS'] == 3 || sku['INVENTORY_STATUS'] == 7 || sku['INVENTORY_STATUS'] == 2;
      });

      if(skus.length === notShoppable.length){
        // All inventory not shoppable
        // determine product status
        var inventoryStatus = [];
        $.each(skus, function(index, sku) {
          inventoryStatus.push(sku['INVENTORY_STATUS']);
        });
        inventoryStatus = _.uniq(inventoryStatus);
        if(inventoryStatus.length == 1){
          // all inventory the same
          productStatus[inventoryStatus[0]] = {};
          productStatus[inventoryStatus[0]][product.PRODUCT_ID] = 7;
        }else if(inventoryStatus.length > 1){
          // inventory mixed
          productStatus['mixed'] = {};
          productStatus['mixed'][product.PRODUCT_ID] = 7;
        }
      }
    }
  });

  // PHF 20151125 i252537: Sort MPPs based on ticker invoice status
  // 1. Shoppable 2. Coming Soon 3. Out of Stock 4. Sold Out
  if ( page_data['catalog-mpp'] ){
    isMpp = 1;
  }
  if ( isMpp ) {
    var productsArray = page_data['catalog-mpp'],
        productsArray = !!productsArray.categories ? productsArray.categories[0] : [],
        productsArray = !!productsArray.products ? productsArray.products : [];
    var productsArraySoldOut = [];
    var productsArrayOutOfStock = [];
    var productsArrayComingSoon = [];
    var productsArrayMixed = [];

    if ( productStatus['mixed'] ) {
        productsArrayMixed = _.filter(productsArray, function(p){ return productStatus['mixed'][p.PRODUCT_ID] });
        productsArray = _.difference(productsArray, productsArrayMixed);
    }
    if ( productStatus[7] ) {
        productsArraySoldOut = _.filter(productsArray, function(p){ return productStatus[7][p.PRODUCT_ID] });
        productsArray = _.difference(productsArray, productsArraySoldOut);
    }
    if ( productStatus[2] ) {
        productsArrayOutOfStock = _.filter(productsArray, function(p){ return productStatus[2][p.PRODUCT_ID] });
        productsArray = _.difference(productsArray, productsArrayOutOfStock);
    }
    if ( productStatus[3] ) {
        productsArrayComingSoon = _.filter(productsArray, function(p){ return productStatus[3][p.PRODUCT_ID] });
        productsArray = _.difference(productsArray, productsArrayComingSoon);
    }
    productsArray = productsArray.concat(productsArrayMixed);
    productsArray = productsArray.concat(productsArrayComingSoon);
    productsArray = productsArray.concat(productsArrayOutOfStock);
    productsArray = productsArray.concat(productsArraySoldOut);
    // and refresh mpp 
    site.productSort.sort(productsArray);
    // This is redundant, so I'm commenting it out
    // $(document).trigger('MPP:adjustMppProductHeights')
  }

  $(".js-inv-status-list").trigger("inventory_status_stored");
  $(".js-add-to-cart").trigger("inventory_status_stored");
  $(".js-quickshop-button").trigger("inventory_status_stored");
  //code will trigger the select box change event on spp page
  if($('div.spp .selectBox').length)
  {
    $('.selectBox').trigger('change');
  }
});


// site.productView.displayInvStatus = function() {
//   if(_.isUndefined($listNode)) return null; 
//   if ($listNode.length < 1) return null;
//   var skuId = $listNode.attr("data-skuid");
//   if (_.isUndefined(skuId) || skuId.length < 1) return null;
//   var skuData = $(document).data(skuId);
//   if (!skuData || !skuData.INVENTORY_STATUS) return null;
//   $("li", $listNode).hide();
//   $(".js-inv-status-" + skuData.INVENTORY_STATUS, $listNode).show();
// };


site.productView.InvStatusList = function($listNode) {
  var that = {
    $listNode : $listNode
  };
  that.productId = that.$listNode.attr("data-product-id");
  
  that.$listNode.on("inventory_status_stored", function(e) {
    that.updateInvStatus();
    e.stopPropagation();
  });

  that.updateInvStatus = function() {
    var skuId = that.$listNode.attr("data-sku-id");
    var skuData = $(document).data(skuId);
    if (!skuData || !skuData.INVENTORY_STATUS) return null;
    $("li", that.$listNode).hide();
    $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode).show();
    var $statusToShow = $(".js-inv-status-" + skuData.INVENTORY_STATUS, that.$listNode);

    // handle retail exclusive skus
    var retail_exclusive_node = that.$listNode.find('.retail-exclusive');
    var is_retail_exclusive = retail_exclusive_node.length;

    if(is_retail_exclusive) {
      $statusToShow = retail_exclusive_node;
    }

    if (is_retail_exclusive || $statusToShow.length > 0) {
      $statusToShow.show();
      that.$listNode.trigger("inventory_status_updated");
    }
  };

  that.updateInvStatus();

  that.$listNode.on('sku:select', function(e, skuData) {
    that.$listNode.attr("data-sku-id", skuData.SKU_ID);
    that.updateInvStatus();
    e.stopPropagation();
  });

  return that;
};

site.productView.collectProductIds = function($context) {
  var prodIds = [];
  $('[data-product-id]', $context).each( function() {
      $this = $(this);
      var prodId = $this.attr('data-product-id');
      var insert = true;
      for (var i=prodIds.length-1; i>-1; i--) {
          if (prodIds[i] == prodId) {
              insert = false;
              break;
          }
      }
      if (insert) {
          prodIds.push(prodId);
      }
      insert = true;
  });
  return prodIds;
};

site.productView.loadL2Data = function(productIds) {
  
  if (!_.isArray(productIds) || productIds.length<1) return null;
  
  generic.jsonrpc.fetch({
    "method":   "prodcat.querykey",
    "params":   [{
        products: productIds,
        query_key: 'catalog-mpp-volatile'
    }],
    "onSuccess" : function (response) {
        var v = response.getValue();
        $(document).trigger('prodcat.status', v);
    }
   });
  
};

site.quickShopExposed = function(skuData) {
  var skuDetail = skuData.SKU_ID ? skuData.SKU_ID : "SKU" + skuData.skuId;
  var skuInfo = $(document).data(skuDetail);
  var $addToBagBtn = site.client.isMobile ? $('.product-brief__quickshop-container .js-add-to-cart') : $('.quickshop.extended-mpp-qs .js-add-to-cart');
  var $activePreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_active_msg') : $('.quickshop.extended-mpp-qs .pre-order_active_msg');
  var $tosPreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_tos_msg') : $('.quickshop.extended-mpp-qs .pre-order_tos_msg');
  var $soldOutPreOrderStatus = site.client.isMobile ? $('.product-brief__quickshop-container .pre-order_sold_msg') : $('.quickshop.extended-mpp-qs .pre-order_sold_msg');
  var $inventortStatusList = site.client.isMobile ? $('.product-brief__quickshop-container .js-inv-status-list') : $('.quickshop.extended-mpp-qs .js-inv-status-list');
  if(skuInfo.isPreOrder) {
  $addToBagBtn.addClass('pre-order-button pre-order-exposed-button').text(site.translations.product.pre_order);
    if(skuInfo.INVENTORY_STATUS  == 7 ) {
      $soldOutPreOrderStatus.removeClass('hidden');
      $tosPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuInfo.INVENTORY_STATUS  == 2 ) {
      site.setPreorderMessage($tosPreOrderStatus, $tosPreOrderStatus.html(), skuInfo, false);
      $soldOutPreOrderStatus.addClass('hidden');
      $activePreOrderStatus.addClass('hidden');
      $addToBagBtn.addClass('pre-order-button-disabled');
      $inventortStatusList.hide();
    }
    else if(skuInfo.INVENTORY_STATUS  == 1 ) {
      site.setPreorderMessage($activePreOrderStatus, $activePreOrderStatus.html(), skuInfo, true);
      $tosPreOrderStatus.addClass('hidden');
      $soldOutPreOrderStatus.addClass('hidden');
      $addToBagBtn.removeClass('pre-order-button-disabled');
    }
  }
  else {
    $addToBagBtn.text(site.translations.product.add_to_bag);
    $addToBagBtn.removeClass('pre-order-button');
    $activePreOrderStatus.addClass('hidden');
    $tosPreOrderStatus.addClass('hidden');
    $soldOutPreOrderStatus.addClass('hidden');
    $inventortStatusList.show();
  }
};

(function($) {
  Drupal.behaviors.ELB_invStatusList = {
    attach: function(context, settings) {
      $('.js-inv-status-list').each( function() {
        var invStatusList = site.productView.InvStatusList($(this));
      });

      $(".js-quickshop-button").each(function(){
        $(this).on('inventory_status_stored', function(e) {
          var currentSkuId = "SKU" + $(this).attr("data-sku-base-id");
          var skuDataL2 = $(document).data(currentSkuId);
          if (skuDataL2 && !skuDataL2.isShoppable) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      });

    }
  };
})(jQuery);

